// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.checkout-freight-wrapper {
  padding: var(--spacing-regular);
  border-radius: var(--border-radius-secondary) !important;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 20, 0.12);
  background-color: var(--color-button-text);
  cursor: auto;
}
.checkout-freight-wrapper .vert-paragraph {
  font-size: var(--font-paragraph);
  font-weight: 500;
  line-height: 24px;
  cursor: auto;
}
.checkout-freight-wrapper .vert-paragraph span {
  font-weight: 400;
}
.checkout-freight-wrapper .vert-paragraph span:before {
  content: ' ';
}
.checkout-freight-wrapper .checkout-freight-title {
  display: flex;
  align-items: center;
  gap: var(--spacing-extra-small);
  margin-bottom: var(--spacing-small);
}
.checkout-freight-wrapper .checkout-freight-title .vert-icon {
  cursor: auto;
}
.checkout-freight-wrapper .checkout-freight-title .vert-icon svg {
  width: 18px;
  height: 18px;
  fill: var(--color-neutral-dark-darker);
}
.checkout-freight-wrapper .checkout-freight-title .vert-title {
  font-size: var(--font-medium);
  font-weight: 600;
  line-height: 24px !important;
  margin: 0;
  text-align: left;
  cursor: auto;
}
.checkout-freight-wrapper .checkout-freight-value .free {
  font-weight: 500;
  color: var(--color-highlight);
}
@media screen and (max-width: 768px) {
  .checkout-freight-wrapper {
    padding: var(--spacing-small);
    background-color: var(--color-button-text);
  }
}
`, "",{"version":3,"sources":["webpack://./src/Assets/styles/default/components/Checkout/CheckoutFreightStyles.less"],"names":[],"mappings":"AACA;EACE,+BAAA;EACA,wDAAA;EACA,gDAAA;EACA,0CAAA;EACA,YAAA;AAAF;AALA;EAQI,gCAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;AAAJ;AAXA;EAaM,gBAAA;AACN;AAAM;EACE,YAAA;AAER;AAjBA;EAqBI,aAAA;EACA,mBAAA;EACA,+BAAA;EACA,mCAAA;AADJ;AAvBA;EA2BM,YAAA;AADN;AA1BA;EA6BQ,WAAA;EACA,YAAA;EACA,sCAAA;AAAR;AA/BA;EAoCM,6BAAA;EACA,gBAAA;EACA,4BAAA;EACA,SAAA;EACA,gBAAA;EACA,YAAA;AAFN;AAvCA;EA+CM,gBAAA;EACA,6BAAA;AALN;AAWA;EACE;IACE,6BAAA;IACA,0CAAA;EATF;AACF","sourcesContent":["// DESKTOP\n.checkout-freight-wrapper {\n  padding: var(--spacing-regular);\n  border-radius: var(--border-radius-secondary) !important;\n  box-shadow: 0px 2px 8px 0px rgba(0, 0, 20, 0.12);\n  background-color: var(--color-button-text);\n  cursor: auto;\n\n  .vert-paragraph {\n    font-size: var(--font-paragraph);\n    font-weight: 500;\n    line-height: 24px;\n    cursor: auto;\n    span {\n      font-weight: 400;\n      &:before {\n        content: ' ';\n      }\n    }\n  }\n\n  .checkout-freight-title {\n    display: flex;\n    align-items: center;\n    gap: var(--spacing-extra-small);\n    margin-bottom: var(--spacing-small);\n\n    .vert-icon {\n      cursor: auto;\n      svg {\n        width: 18px;\n        height: 18px;\n        fill: var(--color-neutral-dark-darker);\n      }\n    }\n\n    .vert-title {\n      font-size: var(--font-medium);\n      font-weight: 600;\n      line-height: 24px !important;\n      margin: 0;\n      text-align: left;\n      cursor: auto;\n    }\n  }\n\n  .checkout-freight-value {\n    .free {\n      font-weight: 500;\n      color: var(--color-highlight);\n    }\n  }\n}\n\n// MOBILE\n@media screen and (max-width: 768px) {\n  .checkout-freight-wrapper {\n    padding: var(--spacing-small);\n    background-color: var(--color-button-text);\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
